import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { UpdateEmspUserOcpiTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/emsp-users/update-emsp-user-ocpi-token.model';
import React from 'react';
import { SubmitErrorHandler } from 'react-hook-form';

import { useUpdateEmspBoEmspUserOcpiTokenContext } from '../../emsp-bo-emsp-user.context';
import { EmspBoEmspUserOcpiTokenUpdateFormStep1Controller } from '../emsp-bo-emsp-user-ocpi-token-update-form-step-1/emsp-bo-emsp-user-ocpi-token-update-form-step-1.controller';

// /////////////////////////////////////////////////////////////////////////////

interface EmspBoEmspUserOcpiTokenUpdateFormControllerProps {
  onError: SubmitErrorHandler<UpdateEmspUserOcpiTokenModel>;
  onSubmit: SubmitHandlerWithDirtyFields<UpdateEmspUserOcpiTokenModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const EmspBoEmspUserOcpiTokenUpdateFormController = (
  props: EmspBoEmspUserOcpiTokenUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useUpdateEmspBoEmspUserOcpiTokenContext();

  return (
    <MultiStepFormProvider<UpdateEmspUserOcpiTokenModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['type', 'language', 'isActivated', 'isRevoked', 'themeId'],
          component: <EmspBoEmspUserOcpiTokenUpdateFormStep1Controller />,
        },
      ]}
    />
  );
};
